// ราคาของหน่วยที่เลือก จากสูตรราคาของหน่วยนั้นเอง (unit.prices จาก /api/unitOptions)
// เช่น สกรูกล่องละ 240 — ไม่ใช่ราคาถุง 25 × 10 = 250
// ไล่จากระดับราคาที่เลือกลงไปจนถึงราคาสด เหมือนราคาหน่วยมาตรฐานในหน้าสินค้า
// คืน null ถ้าหน่วยนี้ไม่มีสูตรราคา หรือระดับราคานี้ถูกซ่อน (หน้าร้านยังไม่ปลดล็อค)
// → ผู้เรียกคิดจากราคาหน่วยมาตรฐาน × อัตราส่วนแทน
export function ownUnitPrice(unit, level) {
  const prices = unit?.prices;
  const lvl = Number(level) || 0;
  if (!prices || prices[`price_${lvl}`] === undefined) return null;
  for (let l = lvl; l >= 0; l--) {
    const n = parseFloat(String(prices[`price_${l}`] ?? '').replace(/,/g, ''));
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}
